import { useQueries, useQueryClient } from "@tanstack/react-query";

import { getPorkFootprintByYear, getPorkFootprintByYearAdmin } from "services";

import { getActiveToken, getEnvironment, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_PORK } from "consts";

export const useGetFootprintingPorkFootprints = (farmId?: string, years: number[] = [], { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  const { user } = useUserContext();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getActiveToken();

  // User context hook returns `null` on admin for whatever reason
  const isLoggedIn = isAdmin ? !!token : !!user && !!token;

  return useQueries({
    queries: years.map((year) => ({
      queryKey: [FOOTPRINTING_PORK, farmId, year, isAdmin],
      queryFn: () => (isAdmin ? getPorkFootprintByYearAdmin(farmId ?? "", year) : getPorkFootprintByYear(year)),
      enabled:
        enabled &&
        carbonProgram?.platformFeatures?.footprinting?.enabled &&
        carbonProgram.platformFeatures.footprinting.pork === true &&
        !!farmId &&
        !!year &&
        isLoggedIn,
      queryClient,
      gcTime: 60000,
    })),
  });
};
